/**
 * @description 服务
 */
export default [{
  path: '/serve/clause', //条款
  name: 'serve_clause',
  component: () => import('@/views/serve/Clause.vue'),
  meta: {
    title: '油柑网-条款',
    requiresAuth: false,
    bodyColor: true
  }
}]